import React, { useRef, useEffect } from 'react';

import TypeIt from 'typeit';

const Type = ({ words }) => {
	const ref = useRef(null);

	useEffect(() => {
		if (ref.current) {
			const typeit = new TypeIt(ref.current, {
				loop: true
			});

			words.forEach(word => {
				typeit
					.type(word)
					.pause(1000)
					.delete()
					.pause(2000);
			});

			typeit.go();
		}
	}, [ref]);

	return <span className="type-it-text" ref={ref}></span>;
};

export default Type;
